// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".transition-enter{--tw-bg-opacity:1;background-color:rgba(253, 108, 67, var(--tw-bg-opacity));height:100vh;top:0}.transition-enter,.transition-leave{width:100%;position:fixed;left:0;z-index:99999}.transition-leave{--tw-bg-opacity:1;background-color:rgba(253, 108, 67, var(--tw-bg-opacity));height:0;bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
